import { render, staticRenderFns } from "./stopSalaryPopup.vue?vue&type=template&id=0ca0270a&scoped=true"
import script from "./stopSalaryPopup.vue?vue&type=script&lang=js"
export * from "./stopSalaryPopup.vue?vue&type=script&lang=js"
import style0 from "./stopSalaryPopup.vue?vue&type=style&index=0&id=0ca0270a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca0270a",
  null
  
)

export default component.exports